// SYSTEMS
export const SET_CONFIG = 'SET_CONFIG';
export const SET_CONFIG_KEY = 'SET_CONFIG_KEY';
export const SET_DASHBOARD = 'SET_DASHBOARD';
export const SET_LEFT_SIDEBAR_CONFIG = 'SET_LEFT_SIDEBAR_CONFIG';
export const SET_PALETTE = 'SET_PALETTE';
export const RESET_PALETTES = 'RESET_PALETTES';

// AUTH
export const SET_AUTH_ME = 'SET_AUTH_ME';
export const SET_AUTH_ME_ERROR = 'SET_AUTH_ME_ERROR';
export const SET_AUTH_OWNER_ID = 'SET_AUTH_OWNER_ID';

// UPLOADED_CSV
export const SET_UPLOADED_CSV = 'SET_UPLOADED_CSV';
export const SET_CUSTOMIZED_CSV = 'SET_CUSTOMIZED_CSV';
export const RESET_UPLOAD_JOB_DATA = 'RESET_UPLOAD_JOB_DATA';

// ROUTE
export const GET_ROUTE = 'GET_ROUTE';

// TOKEN
export const SET_TOKEN = 'SET_TOKEN';

// TRIP
export const GET_TRIP_LIST = 'GET_TRIP_LIST';
export const GET_TRIP_DETAILS = 'GET_TRIP_DETAILS';
export const POST_TRIP_TYPE = 'POST_SESSSION_TYPE';
export const POST_TRIP_STOPS = 'POST_TRIP_STOPS';
export const POST_TRIP_BOOKING = 'POST_TRIP_BOOKING';
export const POST_TRIP_UPDATE_CLUSTERING = 'POST_TRIP_UPDATE_CLUSTERING';
export const UPDATE_SELECTED_TRIP_DATA = 'UPDATE_SELECTED_TRIP_DATA';
export const PUT_TRIP_CANCEL = 'PUT_TRIP_CANCEL';

// EMPLOYEE
export const GET_EMPLOYEE_LIST = 'GET_EMPLOYEE_LIST';
export const GET_EMPLOYEE_INFO = 'GET_EMPLOYEE_INFO';
export const GET_EMPLOYEE_WITH_QUERY = 'GET_EMPLOYEE_WITH_QUERY';
export const POST_EMPLOYEE = 'POST_EMPLOYEE';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';
export const UPDATE_EMPLOYEE_STATUS = 'UPDATE_EMPLOYEE_STATUS';

// SOCKET
export const SOCKET_UPDATE = 'SOCKET_UPDATE';
export const TRACKING_CHANNEL_UPDATE = 'TRACKING_CHANNEL_UPDATE';
export const TRACKING_CHANNEL_RESET = 'TRACKING_CHANNEL_RESET';
export const BUS_LIST_UPDATE = 'BUS_LIST_UPDATE';
export const BUS_LIST_RESET = 'BUS_LIST_RESET';
export const LOCATION_UPDATE = 'LOCATION_UPDATE';

// OWNER
export const OWNER_LIST = 'OWNER_LIST';
export const UPDATE_SELECTED_OWNER_ID = 'OWNER_UPDATE_SELECTED_OWNER_ID';

// CHAT (SMS/WhatsApp OTP Login + Chatwoot)
export const CHAT_LOGIN = 'CHAT_LOGIN';
export const CHAT_VERIFY_OTP = 'CHAT_VERIFY_OTP';
export const CHAT_GET_CHATWOOT_TOKEN = 'CHAT_GET_CHATWOOT_TOKEN';
export const CHAT_SET_AUTH_TOKEN = 'CHAT_SET_AUTH_TOKEN';
export const CHAT_SET_CHATWOOT_READY = 'CHAT_SET_CHATWOOT_READY';
